import styled from 'styled-components';

import { webStyles } from 'hb-react/shared/constants/styles';

// Most of the styles in here are from app/assets/legacy/stylesheets/components/ckeditor_content.scss
export const DivWithWebStyles = styled.div`
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  position: relative;
  overflow: auto;

  ${({ theme }) => webStyles(theme)}
`;
